import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface OnboardingChecklistItem {
  id: string;
  user_id: string;
  step_key: string;
  step_name: string;
  is_completed: boolean;
  completed_at: string | null;
}

export function useStaffOnboarding(userId: string | undefined) {
  return useQuery({
    queryKey: ["staff-onboarding", userId],
    queryFn: async () => {
      if (!userId) return [];
      const { data, error } = await supabase
        .from("staff_onboarding_checklist" as any)
        .select("*")
        .eq("user_id", userId)
        .order("created_at", { ascending: true });
      if (error) throw error;
      return (data || []) as unknown as OnboardingChecklistItem[];
    },
    enabled: !!userId,
  });
}

export function computeOnboardingStatus(items: OnboardingChecklistItem[]) {
  if (!items || items.length === 0) return { total: 0, completed: 0, percentage: 0, incomplete: [] as OnboardingChecklistItem[] };
  const completed = items.filter(i => i.is_completed).length;
  const incomplete = items.filter(i => !i.is_completed);
  return {
    total: items.length,
    completed,
    percentage: Math.round((completed / items.length) * 100),
    incomplete,
  };
}
